import { useEffect } from 'react';

import { useWorkspaceAgentPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceAgentPanelStore';

export const usePrivateWorkspaceAgentOnboardingHandoffSession = (sessionId: string | null) => {
  const onboardingHandoff = useWorkspaceAgentPanelStore((state) => state.onboardingHandoff);
  const onboardingHandoffSession = useWorkspaceAgentPanelStore((state) => state.onboardingHandoffSession);
  const setOnboardingHandoff = useWorkspaceAgentPanelStore((state) => state.setOnboardingHandoff);
  const setOnboardingHandoffSession = useWorkspaceAgentPanelStore((state) => state.setOnboardingHandoffSession);

  const showOnboardingSimulation = onboardingHandoff !== null;

  useEffect(() => {
    if (onboardingHandoff === null) {
      return;
    }

    if (onboardingHandoffSession === null) {
      setOnboardingHandoffSession({
        boundSessionId: null,
        openingSessionId: sessionId,
      });
      return;
    }

    // The reset after Review onboarding drops the previous thread, then the live send opens a new
    // one. That first change is the intro's thread, not the user leaving it.
    if (sessionId === null || sessionId === onboardingHandoffSession.openingSessionId) {
      return;
    }

    if (onboardingHandoffSession.boundSessionId === null) {
      setOnboardingHandoffSession({
        boundSessionId: sessionId,
        openingSessionId: onboardingHandoffSession.openingSessionId,
      });
      return;
    }

    if (onboardingHandoffSession.boundSessionId !== sessionId) {
      setOnboardingHandoff(null);
    }
  }, [onboardingHandoff, onboardingHandoffSession, sessionId, setOnboardingHandoff, setOnboardingHandoffSession]);

  return { showOnboardingSimulation };
};
